const Product = [
    {
      id: '31',
      department:"1",
      name: 'Mauris at orci non vulputate diam tincidunt nec.',
      code:"Code - Y523201",
      Text:"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Velit facilisis quis auctor pretium ipsum, eu rutrum. Condimentum eu malesuada vitae ultrices in in neque, porta dignissim. Adipiscing purus, cursus vulputate id id dictum at.",
      image:'/image/blo1.png',
      
          },
   {
    id:'2',
    department:"1",
    name: 'Mauris at orci non vulputate diam tincidunt nec.',
    code:"Code - Y523201",
    Text:"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Velit facilisis quis auctor pretium ipsum, eu rutrum. Condimentum eu malesuada vitae ultrices in in neque, porta dignissim. Adipiscing purus, cursus vulputate id id dictum at.",
    image:'/image/blo2.png',
    
         },
    {
      id: '33',
      department:"1",
      name: 'Mauris at orci non vulputate diam tincidunt nec.',
      code:"Code - Y523201",
      Text:"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Velit facilisis quis auctor pretium ipsum, eu rutrum. Condimentum eu malesuada vitae ultrices in in neque, porta dignissim. Adipiscing purus, cursus vulputate id id dictum at.",
      image:'/image/blo3.png',
      
                      },
  
        

         
     

  ];
  
  export default Product;